import {Fragment, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {MGateWayService} from '../../../lich-su-truyen-nhan/MGateWayService';
import {ToastService} from '../../../../AppToast';
import {ConfirmDialogService} from '../../../../AppConfirmDialog';

import {TransferLogs} from '../../../lich-su-truyen-nhan/component/TransferLogs';
import {useTranslation} from '../../../../shared/language';

export const DialogViewTransferLog = (props) => {

  const {t} = useTranslation();

  const type = 'WrongInvoice,WrongInvoiceCash';

  const {display, setDisplay, selectedItem} = props;

  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);

  const rollbackStatus = () => {
    ConfirmDialogService.confirm(t('common.confirm'), t('common.restoreErrorNoticeStatusQuestion'), () => {
      MGateWayService.rollbackStatus(type, [selectedItem.id]).then(() => {
        setVersion(Date.now());
        ToastService.success(t('common.restoreSuccess'));
      });
    });
  }

  const getResult = () => {
    MGateWayService.getResult(selectedItem.id, type).then(() => {
      setVersion(Date.now());
      ToastService.success(t('common.reloadSuccess'));
    });
  }

  return (
    <Dialog header={t('common.invoiceTransferHistory')} visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
      {selectedItem &&
				<Fragment>
					<p><b>{t('report.errorNoticeDescription')}</b></p>
					<TransferLogs type={type} invoice={selectedItem} rows={20} heightCalc={200} idAction={selectedItem.id} version={version}
												setCanRollback={setCanRollback}/>
				</Fragment>
      }

      <div className="flex justify-content-end mt-2">
        {/* {canRollback &&
					<Button label="Khôi phục trạng thái" className="p-button-outlined p-button-sm mr-2" onClick={rollbackStatus}/>
        } */}
        <Button label={t('common.check')} className="p-button-outlined p-button-sm mr-2" onClick={getResult}/>
        <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm"/>
      </div>
    </Dialog>
  );
}
